<!--
 Name: Team.vue
 Description: View to display the team page.
 Created by: Jana Schumann on 2019-11-07
 Last edited by: Jana Schumann on 2025-09-02
-->

<template>
  <v-container fluid class="pa-0 full-width">
    <!-- team -->
    <section id="all">
      <v-container class="mb-15">

        <h2 class="my-12">{{ $t("team.core_headline") }}</h2>
        <p class="text-justify mb-15">{{ $t("team.core_text") }}</p>

        <!-- core team -->
        <v-row>
          <v-col cols="12" sm="6" md="3" v-for="(member, index) in team" :key="index">
            <v-img class="bg-grey-lighten-2" :src="require(`@/assets/images/team/${member.image}`)" aspect-ratio="0.75" cover />
            <p class="mt-3 text-center">
              <b>{{ member.name }}</b>
              <br />
              {{ member.title }}
            </p>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="d-flex flex-column justify-center align-center">
            <p class="mt-3 text-center font-italic">
              {{ $t("team.core_more") }}
            </p>
          </v-col>
        </v-row>
      </v-container>
      <v-divider />
    </section>

    <!-- science -->
<!--    <section id="team-science">-->
<!--      <v-container class="mb-15">-->
<!--        <h2 class="my-12 text-center">{{ $t("team.science_headline") }}</h2>-->
<!--        <p class="text-center mb-15">{{ $t("team.science_text") }}</p>-->

<!--        <v-row justify="center">-->
<!--          <v-col cols="12" sm="6" md="3" class="pr-5">-->
<!--            <v-img class="bg-grey-lighten-2" :src="require(`@/assets/images/team/science/wolfgang-hoffmann.jpg`)" aspect-ratio="1">-->
<!--            </v-img>-->
<!--            <p class="mt-3 text-center">-->
<!--              <b>{{ $t("team.science_name_hoffmann") }}</b>-->
<!--              <br />-->
<!--              {{ $t("team.science_institute_hoffmann") }}-->
<!--              <br />-->
<!--              {{ $t("team.science_research_hoffmann") }}-->
<!--            </p>-->
<!--          </v-col>-->
<!--          <v-col cols="12" sm="6" md="3" class="pr-5">-->
<!--            <v-img class="bg-grey-lighten-2" :src="require(`@/assets/images/team/science/robert-howard.jpg`)" aspect-ratio="1">-->
<!--            </v-img>-->
<!--            <p class="mt-3 text-center">-->
<!--              <b>{{ $t("team.science_name_howard") }}</b>-->
<!--              <br />-->
<!--              {{ $t("team.science_institute_howard") }}-->
<!--              <br />-->
<!--              {{ $t("team.science_research_howard") }}-->
<!--            </p>-->
<!--          </v-col>-->
<!--          <v-col cols="12" sm="6" md="3" class="pr-5">-->
<!--            <v-img class="bg-grey-lighten-2" :src="require(`@/assets/images/team/science/william-jagust.jpg`)" aspect-ratio="1">-->
<!--            </v-img>-->
<!--            <p class="mt-3 text-center">-->
<!--              <b>{{ $t("team.science_name_jagust") }}</b>-->
<!--              <br />-->
<!--              {{ $t("team.science_institute_jagust") }}-->
<!--              <br />-->
<!--              {{ $t("team.science_research_jagust") }}-->
<!--            </p>-->
<!--          </v-col>-->
<!--        </v-row>-->

<!--        <v-row justify="center">-->
<!--          <v-col cols="12" sm="6" md="3" class="pr-5">-->
<!--            <v-img class="bg-grey-lighten-2" :src="require(`@/assets/images/team/science/frank-jessen.jpg`)" aspect-ratio="1">-->
<!--            </v-img>-->
<!--            <p class="mt-3 text-center">-->
<!--              <b>{{ $t("team.science_name_jessen") }}</b>-->
<!--              <br />-->
<!--              {{ $t("team.science_institute_jessen") }}-->
<!--              <br />-->
<!--              {{ $t("team.science_research_jessen") }}-->
<!--            </p>-->
<!--          </v-col>-->
<!--          <v-col cols="12" sm="6" md="3" class="pr-5">-->
<!--            <v-img class="bg-grey-lighten-2" :src="require(`@/assets/images/team/science/pierluigi-nicotera.jpg`)" aspect-ratio="1">-->
<!--            </v-img>-->
<!--            <p class="mt-3 text-center">-->
<!--              <b>{{ $t("team.science_name_nicotera") }}</b>-->
<!--              <br />-->
<!--              {{ $t("team.science_institute_nicotera") }}-->
<!--              <br />-->
<!--              {{ $t("team.science_research_nicotera") }}-->
<!--            </p>-->
<!--          </v-col>-->
<!--          <v-col cols="12" sm="6" md="3" class="pr-5">-->
<!--            <v-img class="bg-grey-lighten-2" :src="require(`@/assets/images/team/science/lars-nyberg.jpg`)" aspect-ratio="1">-->
<!--            </v-img>-->
<!--            <p class="mt-3 text-center">-->
<!--              <b>{{ $t("team.science_name_nyberg") }}</b>-->
<!--              <br />-->
<!--              {{ $t("team.science_institute_nyberg") }}-->
<!--              <br />-->
<!--              {{ $t("team.science_research_nyberg") }}-->
<!--            </p>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--      </v-container>-->
<!--    </section>-->
  </v-container>
</template>

<script>
import _ from 'lodash'

export default {
  data() {
    return {
      team: [
        {
          image: 'core/david-berron.jpg',
          name: 'Dr. David Berron',
          title: 'Founder and Chief Science Officer'
        },
        {
          image: 'core/emrah-duezel.jpg',
          name: 'Prof. Dr. med. Emrah Düzel',
          title: 'Founder and Chief Medical Officer'
        },
        {
          image: 'core/dominik-boeke.jpeg',
          name: 'Dr. Dominik Böke',
          title: 'Chief Executive Officer'
        },
        {
          image: 'core/florian-boesenkopf.jpg',
          name: 'Florian Bösenkopf',
          title: 'Chief Financial Officer'
        },
        {
          image: 'core/maike-kuehn.jpg',
          name: 'Maike Kühn',
          title: 'Chief of Staff'
        },
        {
          image: 'core/hannes-voßfeldt.jpg',
          name: 'Dr. Hannes Voßfeldt',
          title: 'Project Manager Digital Healthcare'
        },
        {
          image: 'core/bernd-neutschel.jpg',
          name: 'Dr. Bernd Neutschel',
          title: 'Chief Operations Officer'
        },
        {
          image: 'core/xandra-volkmann.jpg',
          name: 'Dr. Xandra Volkmann',
          title: 'Team Lead QM & Regulatory, PRRC'
        },
        {
          image: 'core/florian-heinzmann.jpg',
          name: 'Dr. Florian Heinzmann',
          title: 'Senior Regulatory Affairs Manager'
        },
        {
          image: 'core/nadine-diersch.jpg',
          name: 'Dr. Nadine Diersch',
          title: 'Team Lead Science & Innovation'
        },
        {
          image: 'core/paula-saering.jpg',
          name: 'Dr. Paula Säring',
          title: 'Senior Project Manager Study Coordination'
        },
        {
          image: 'core/jana-schumann.jpg',
          name: 'Jana Schumann',
          title: 'Chief Technology Officer'
        },
        {
          image: 'core/eva-ackermann.jpg',
          name: 'Eva Ackermann',
          title: 'Team Lead Sales & Market Access'
        },
        {
          image: 'core/chris-rehse.jpg',
          name: 'Dr. Chris Rehse',
          title: 'Founder'
        }
      ]
    }
  }
};
</script>
